import { Engine1Proxy, ConciergeProxy, RestApiProxy } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import ProcessManager from '../../../Common/Managers/ProcessManager'

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

export const INITIAL_STATE = "INITIAL_STATE";
export const SET_USER_FUNCTIONS = "SET_USER_FUNCTIONS";
export const ABRIR_MODAL = "ABRIR_MODAL";
export const EXPANDIR_ROW_CONFIRMADOR_AJUSTES_CARGOS = "EXPANDIR_ROW_CONFIRMADOR_AJUSTES_CARGOS";
export const CAMBIAR_ESTADO = "CAMBIAR_ESTADO";
export const ACTUALIZA_FECHA = "ACTUALIZA_FECHA";
export const FOMARTO_FECHA_MODAL_ESTADOS = "FOMARTO_FECHA_MODAL_ESTADOS";
export const GET_DATA_CONFIRMADOR = "GET_DATA_CONFIRMADOR";
export const AGREGAR_USUARIO_MODAL_ESTADOS = "AGREGAR_USUARIO_MODAL_ESTADOS";
export const ELIMINAR_USUARIO_MODAL_ESTADOS = "ELIMINAR_USUARIO_MODAL_ESTADOS";
export const GUARDAR_OBJ_FILTRADO = "GUARDAR_OBJ_FILTRADO";
export const REINICIAR_MODAL_ESTADOS = "REINICIAR_MODAL_ESTADOS";
export const DESTILDAR_TILDAR_CHECK = "DESTILDAR_TILDAR_CHECK";
export const DESTILDAR_TILDAR_CHECK_ALL = "DESTILDAR_TILDAR_CHECK_ALL";
export const LOADING_CONFIRMADOR = "LOADING_CONFIRMADOR";
export const GET_DATA_AJUSTES_CARGOS_FILTRO = "GET_DATA_AJUSTES_CARGOS_FILTRO";
export const DESTILDAR_TILDAR_CHECK_AJUSTE_CARGO = "DESTILDAR_TILDAR_CHECK_AJUSTE_CARGO";
export const DESTILDAR_TILDAR_CHECK_ALL_AJUSTE_CARGO = "DESTILDAR_TILDAR_CHECK_ALL_AJUSTE_CARGO";
export const FILTRAR_MOVIMIENTOS_POR_DESCRIPCION = "FILTRAR_MOVIMIENTOS_POR_DESCRIPCION";
export const ACTUALIZAR_MARCA_TIPO_CUENTA = "ACTUALIZAR_MARCA_TIPO_CUENTA";
export const ACTUALIZAR_RADIOBTN_AJUSTE_CARGO = "ACTUALIZAR_RADIOBTN_AJUSTE_CARGO";
export const ACTUALIZAR_IMPORTE_SIN_IVA = "ACTUALIZAR_IMPORTE_SIN_IVA";
export const ACTUALIZAR_TIPO_OPERACION = "ACTUALIZAR_TIPO_OPERACION";
export const MOSTRAR_DATOS_GRILLA = "MOSTRAR_DATOS_GRILLA";
export const LIMPIAR_PANEL_FILTROS = "LIMPIAR_PANEL_FILTROS";
export const MOSTRAR_MODAL_CAMBIAR_ESTADO = "MOSTRAR_MODAL_CAMBIAR_ESTADO";

let _tarjetas;
let _dispatch;
let _userFunctions;
let userFunctions = [];
let userFeatures = [];
let marcaId = undefined;
let tipoMovimiento = undefined;
/**
 * 
 * @param {any} id
 * @param {any} currentScope
 * @param {any} cuenta
 */
export function getScreenData(currentScope) {
    LogHelper.In(getScreenData.name, currentScope);

    //const { UserId, ProductCode, CategoryCode, ProgramCode } = currentScope;

    return (dispatch, getState) => {
        const state = getState();

        _dispatch = dispatch;
        _dispatch({ type: LOADING_CONFIRMADOR, valor: true });

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _loadScreenData(data), null, "GETFUNCTIONS", currentScopeRequest);
    }
}

export function resetState() {
    LogHelper.In(resetState.name);

    return (dispatch) => {
        dispatch({ type: INITIAL_STATE });
    }
}

function _loadScreenData(data) {
    // let funcionesDelUsuario = JSON.parse(JSON.stringify(data.CONFIRMADOR));


    // let param;
    // let functionsAllowed = [];

    // //funcionesDelUsuario.forEach(p => { functionsAllowed[p.Codigo_Funcion] = true  });

    // _userFunctions = functionsAllowed;

    // param = { 'Opcion': 1 }

    // Engine1Proxy.AddDataSourcesRequests(param, 'GET_PROCESOS', 'Get', 'Tarjetas', 'PROCESOS', null, 'User', true);

    // Engine1Proxy.Execute((data) => _loadCargoAjusteMasivosData(data), null, null, "PROCESOS");

    // _dispatch({ type: SET_USER_FUNCTIONS, _userFunctions });
    _loadConfirmadorAjusteCargo(null);
}

function _loadConfirmadorAjusteCargo(data, reset = false) {
    LogHelper.In(_loadConfirmadorAjusteCargo.name, data);

    if(reset) {
        let param = {
            "TIPO_MOVIMIENTO": "A",
            "ID_MARCA": null,
            "TIPO_OPERACION": null,
            "TIPO_CUENTA_ID": null,
            "IMPORTE_MINIMO": null,
            "IMPORTE_MAXIMO": null,
            "ESTADO_ID": null,
            "USUARIO": null,
            "FECHA_ESTADO_DESDE": null,
            "FECHA_ESTADO_HASTA": null,
            "MOTIVO_AJUSTE_CARGO": null
        }

        Engine1Proxy.AddDataSourcesRequests(param, 'GET_AJUSTES_CARGOS_CONFIRMADOR_GRILLA', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    }

    Engine1Proxy.AddDataSourcesRequests(null, 'GET_AJUSTES_DATOS_EXTRAS', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    //SP que carga los usuarios del Modal de Estados
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_USUARIOS_AJUSTES_CARGOS', 'Get', 'Tarjetas', 'PROCESOS', 1, 'User', true);
    //Al no pasarle parametros al SP me devolverá las Marcas y Tipo de Cuenta
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_AJUSTES_CARGOS_CONFIRMADOR', 'Get', 'Tarjetas', 'PROCESOS', 1, 'User', true);


    _dispatch({ type: LOADING_CONFIRMADOR, valor: true });
    Engine1Proxy.Execute((data) => _callBackloadConfirmadorAjusteCargo(data, reset), null, null, "PROCESOS");
}

function _callBackloadConfirmadorAjusteCargo(data, reset) {
    LogHelper.In(_callBackloadConfirmadorAjusteCargo.name, data, reset);

    //Obtengo los usuarios con estado PEND. CONFIRMACION y DENEGADO
    let usuariosEstadoPendConfrimacion = JSON.parse(data.GET_USUARIOS_AJUSTES_CARGOS).Recordset0.Rows;
    let usuariosEstadoDenegado = JSON.parse(data.GET_USUARIOS_AJUSTES_CARGOS).Recordset1.Rows;
    //Obtengo las marcas de tarjetas y tipo de cuentas disponibles
    let marca = JSON.parse(data.GET_AJUSTES_CARGOS_CONFIRMADOR).Recordset0.Rows;
    let tipoCuenta = JSON.parse(data.GET_AJUSTES_CARGOS_CONFIRMADOR).Recordset1.Rows;
    //Obtengo los Estados de Cargo y Ajuste
    const GET_AJUSTES_DATOS_EXTRAS = JSON.parse(data.GET_AJUSTES_DATOS_EXTRAS);
    let ajusteEstados = GET_AJUSTES_DATOS_EXTRAS.Recordset4.Rows ? GET_AJUSTES_DATOS_EXTRAS.Recordset4.Rows : undefined;
    let cargoEstados = GET_AJUSTES_DATOS_EXTRAS.Recordset5.Rows ? GET_AJUSTES_DATOS_EXTRAS.Recordset5.Rows : undefined;

    getMarcaMaster(marca);
    let estadoPendConfirmacion = getEstadosAjusteCargo(true, ajusteEstados, cargoEstados);

    let objFiltrado = {
        login: undefined,
        fechaDesde: "",
        fechaHasta: "",
        estado: "PEND. CONFIRMACIÓN",
        idEstadoAjuste: estadoPendConfirmacion.estadoIdAjuste,
        idEstadoCargo: estadoPendConfirmacion.estadoIdCargo
    };

    if(marca && marca.length > 0) {
        let marcaId = marca.filter(x => x.Codigo.toString().toLowerCase() == "master");
        marcaId = marcaId[0].Id;

        if(marcaId)
            _dispatch({ type: ACTUALIZAR_MARCA_TIPO_CUENTA, campo: "marcaSeleccionada", id: marcaId });
    }

    _dispatch({ type: LOADING_CONFIRMADOR, valor: false });
    _dispatch({ type: GET_DATA_CONFIRMADOR, usuariosEstadoPendConfrimacion, usuariosEstadoDenegado, marca, tipoCuenta, ajusteEstados, cargoEstados, objFiltrado });
    _dispatch({ type: LOADING_CONFIRMADOR, valor: false });

    if(reset) {
        _dispatch({ type: LOADING_CONFIRMADOR, valor: true });
        _callBackObtenerDatosGrilla(data, undefined);
    }
}

function getMarcaMaster(marca) {
    let esMaster = marca && marca.length > 0 ? marca.filter(x => x.Descripcion.toString().toLowerCase() == "master") : undefined;
    let valor = esMaster && esMaster.length > 0 ? esMaster[0].Id : "-1";

    _dispatch({ type: ACTUALIZAR_MARCA_TIPO_CUENTA, campo: "marcaSeleccionada", id: valor });
}

export function abrirModal(muestraModal, id) {
    LogHelper.In(abrirModal.name, id);

    return (dispatch, getState) => {
        let stateConfirmador = getState().ConfirmadorAjusteCargo;
        let marcaIdAux = stateConfirmador.marcaSeleccionada;
        let tipoMovimientoAux = stateConfirmador.rdButtonAjusteCargo;

        if (id == 1 && !muestraModal) {
            dispatch({ type: REINICIAR_MODAL_ESTADOS });
        }

        if (id == 2 && muestraModal) { // ID 2 corresponde al modal de filtros por ajuste/cargo
            dispatch({ type: LOADING_CONFIRMADOR, valor: true });
            if(marcaId == undefined || tipoMovimiento == undefined){
                marcaId = marcaIdAux;
                tipoMovimiento = tipoMovimientoAux;
            } else {
                if((marcaId != marcaIdAux) || (tipoMovimiento != tipoMovimientoAux)){
                    marcaId = marcaIdAux;
                    tipoMovimiento = tipoMovimientoAux;
                    dispatch({ type: LIMPIAR_PANEL_FILTROS });
                }
            }
            getAjustesCargosConfirmador(marcaId, tipoMovimiento)
        }

        dispatch({ type: ABRIR_MODAL, muestraModal: muestraModal, modalId: id });
    }
}

export function camibarEstado(seleccionoPendConfirmacion, seleccionoDenegado) {
    LogHelper.In(camibarEstado.name, seleccionoPendConfirmacion, seleccionoDenegado);
    let fechaEstadoDenegado = "", fechaEstadoPendConfirmacion = "", fechaAux = new Date(), mesActual = new Date().getMonth() + 1;;

    //En caso de haber seleccionado el estado "Denegado" se deberá cargar fecha "Desde" con una fecha 30 días menores a la fecha actual
    if (seleccionoDenegado) {
        fechaEstadoDenegado = obtenerFechaEstadoDenegado();
        fechaEstadoPendConfirmacion = (fechaAux.getDate() > 9 ? fechaAux.getDate() : '0' + fechaAux.getDate()) + '/' + (mesActual > 9 ? mesActual : '0' + mesActual) + '/' + fechaAux.getFullYear();
    } else {
        fechaEstadoDenegado = "";
        fechaEstadoPendConfirmacion = "";
    }

    return (dispatch) => {
        dispatch({
            type: CAMBIAR_ESTADO, seleccionoPendConfirmacion: seleccionoPendConfirmacion, seleccionoDenegado: seleccionoDenegado,
            fechaEstadoDenegado: fechaEstadoDenegado, fechaEstadoPendConfirmacion: fechaEstadoPendConfirmacion
        });
        dispatch({ type: FOMARTO_FECHA_MODAL_ESTADOS, valor: false, errorCampo: "errorDesde" });
        dispatch({ type: FOMARTO_FECHA_MODAL_ESTADOS, valor: false, errorCampo: "errorHasta" });
    }
}

export function validarFormatoFecha(fecha, campo, errorCampo, formatoOk) {
    LogHelper.In(validarFormatoFecha.name, fecha, campo, formatoOk);
    return (dispatch, getState) => {
        if (!formatoOk || validarFechaPosterior(fecha)) {
            _dispatch({ type: ACTUALIZA_FECHA, valor: fecha, campo });
            _dispatch({ type: FOMARTO_FECHA_MODAL_ESTADOS, valor: true, errorCampo });
        }
        else {
            _dispatch({ type: ACTUALIZA_FECHA, valor: fecha, campo });
            _dispatch({ type: FOMARTO_FECHA_MODAL_ESTADOS, valor: false, errorCampo });
        }
    }
}

export function addUsuarioModalEstados(login) {
    LogHelper.In(addUsuarioModalEstados.name, login);

    return (dispatch, getState) => {
        _dispatch({ type: AGREGAR_USUARIO_MODAL_ESTADOS, login });
    }
}

export function aceptarModalEstados() {
    LogHelper.In(aceptarModalEstados.name);

    return (dispatch, getState) => {
        let stateConfirmador = getState().ConfirmadorAjusteCargo;

        if (!stateConfirmador.fechasModalEstados.errorDesde && !stateConfirmador.fechasModalEstados.errorHasta) {
            if (validarFechasDesdeHasta(stateConfirmador.fechasModalEstados.desde, stateConfirmador.fechasModalEstados.hasta)) {
                let estadosAjusteCargo = getEstadosAjusteCargo(stateConfirmador.estadoSeleccionado.esPendConfirmacion, stateConfirmador.ajusteEstados, stateConfirmador.cargoEstados);

                let objFiltrado = {
                    login: stateConfirmador.usuariosModalEstadosSeleccionado,
                    fechaDesde: stateConfirmador.fechasModalEstados.desde,
                    fechaHasta: stateConfirmador.fechasModalEstados.hasta,
                    estado: stateConfirmador.estadoSeleccionado.esPendConfirmacion ? "PEND. CONFIRMACIÓN" : "DENEGADO",
                    idEstadoAjuste: estadosAjusteCargo.estadoIdAjuste,
                    idEstadoCargo: estadosAjusteCargo.estadoIdCargo
                };
                _dispatch({ type: REINICIAR_MODAL_ESTADOS });
                _dispatch({ type: ABRIR_MODAL, muestraModal: false, modalId: 1 });
                _dispatch({ type: GUARDAR_OBJ_FILTRADO, objFiltrado });
            } else {
                _dispatch({ type: FOMARTO_FECHA_MODAL_ESTADOS, valor: true, errorCampo: "errorDesde" });
            }
        }
    }
}

export function destildarTildarCheckFiltroAjusteCargo(movimientoId, estadoCheck) {
    LogHelper.In(destildarTildarCheckFiltroAjusteCargo.name, movimientoId, estadoCheck);
    return (dispatch, getState) => {
        let stateConfirmador = getState().ConfirmadorAjusteCargo;
        let arrayAuxPanel, objAuxPanel;

        if (estadoCheck) {
            arrayAuxPanel = stateConfirmador.movimientosFiltradosParaMostrarPanel.filter(x => x.ID != movimientoId);
        } else {
            objAuxPanel = stateConfirmador.dataModalFiltrosCargoAjuste.filter(x => x.ID == movimientoId)
            objAuxPanel = objAuxPanel && objAuxPanel[0] ? objAuxPanel[0] : objAuxPanel;
            arrayAuxPanel = stateConfirmador.movimientosFiltradosParaMostrarPanel;
        }

        dispatch({ type: DESTILDAR_TILDAR_CHECK_AJUSTE_CARGO, movimientoId, estadoCheck, arrayAuxPanel, objAuxPanel });
    }
}

export function destildarTildarCheckAllFiltroAjusteCargo(estadoCheck, ajusteCargo) {
    LogHelper.In(destildarTildarCheckAllFiltroAjusteCargo.name, estadoCheck, ajusteCargo);

    return (dispatch, getState) => {
        let stateConfirmador = getState().ConfirmadorAjusteCargo;
        let idChecksAjusteCargoArray = ajusteCargo.map(ajusteCargo => ajusteCargo.ID);
        let checkConfirmar = !estadoCheck;
        let dataFiltrosCargoAjuste = stateConfirmador.dataModalFiltrosCargoAjuste;

        dispatch({ type: DESTILDAR_TILDAR_CHECK_ALL_AJUSTE_CARGO, checkConfirmar, idChecksAjusteCargoArray, dataFiltrosCargoAjuste });
    }
}

export function expandirRow(id) {
    LogHelper.In(expandirRow.name, id);

    return (dispatch) => {
        dispatch({ type: EXPANDIR_ROW_CONFIRMADOR_AJUSTES_CARGOS, id: id });
    }
}

export function filtrarMovimientosPorDescripcion(movimientosEncontrados) {
    LogHelper.In(filtrarMovimientosPorDescripcion.name, movimientosEncontrados);

    return (dispatch, getState) => {
        dispatch({ type: FILTRAR_MOVIMIENTOS_POR_DESCRIPCION, movimientosEncontrados });
    }
}

export function selectCombo(campo, id) {
    LogHelper.In(selectCombo.name, campo, id);

    return (dispatch, getState) => {
        dispatch({ type: ACTUALIZAR_MARCA_TIPO_CUENTA, campo, id });
    };
}

export function selectRadioButton(valor) {
    LogHelper.In(selectRadioButton.name, valor);

    return (dispatch, getState) => {
        dispatch({ type: ACTUALIZAR_RADIOBTN_AJUSTE_CARGO, valor });
    };
}

export function actualizarImporteSinIVA(campo, campoError, valor, errorFormato) {
    LogHelper.In(actualizarImporteSinIVA.name, campo, valor);

    return (dispatch, getState) => {
        dispatch({ type: ACTUALIZAR_IMPORTE_SIN_IVA, campo, campoError, errorFormato, valor });
    };
}

export function actualizarTipoOperacion(campo, valor) {
    LogHelper.In(actualizarTipoOperacion.name, campo, valor);

    return (dispatch, getState) => {
        dispatch({ type: ACTUALIZAR_TIPO_OPERACION, campo, valor });
    };
}
//////////////////////////////////// FUNCIONES AUXILIARES ///////////////////////////////////////

function validarImporteMinMax(min, max) {
    return min > max ? false : true;
}

function getEstadosAjusteCargo(pendienteConfirmacion, ajusteEstados, cargoEstados) {
    let estadoIdAjuste, estadoIdCargo;

    if (pendienteConfirmacion) {
        estadoIdAjuste = ajusteEstados.filter((ajusteEstado) => { return ajusteEstado.Descripcion == "Pend. Confirmación" });
        estadoIdAjuste = estadoIdAjuste && estadoIdAjuste.length > 0 ? estadoIdAjuste[0].Id : undefined;

        estadoIdCargo = cargoEstados.filter((cargoEstado) => { return cargoEstado.Descripcion == "Pend. Confirmación" });
        estadoIdCargo = estadoIdCargo && estadoIdCargo.length > 0 ? estadoIdCargo[0].Id : undefined;
    } else {
        estadoIdAjuste = ajusteEstados.filter((ajusteEstado) => { return ajusteEstado.Descripcion == "Denegado" });
        estadoIdAjuste = estadoIdAjuste && estadoIdAjuste.length > 0 ? estadoIdAjuste[0].Id : undefined;

        estadoIdCargo = cargoEstados.filter((cargoEstado) => { return cargoEstado.Descripcion == "Denegado" });
        estadoIdCargo = estadoIdCargo && estadoIdCargo.length > 0 ? estadoIdCargo[0].Id : undefined;
    }

    let estadosAjusteCargo = {
        estadoIdCargo: estadoIdCargo,
        estadoIdAjuste: estadoIdAjuste
    };

    return estadosAjusteCargo;
}

function getAjustesCargosConfirmador(idMarca, tipoMovimiento) {
    LogHelper.In(getAjustesCargosConfirmador.name, idMarca, tipoMovimiento);

    let param = {
        'ID_MARCA': idMarca,
        'TIPO_MOVIMIENTO': tipoMovimiento
    };

    //SP que carga los usuarios del Modal de Estados
    Engine1Proxy.AddDataSourcesRequests(param, 'GET_AJUSTES_CARGOS_CONFIRMADOR', 'Get', 'Tarjetas', 'PROCESOS', 1, 'User', true);
    Engine1Proxy.Execute((data) => _callBackgetAjustesCargosConfirmador(data), null, null, "PROCESOS");
}

function _callBackgetAjustesCargosConfirmador(data) {
    let dataModalFiltrosCargoAjuste = JSON.parse(data.GET_AJUSTES_CARGOS_CONFIRMADOR).Recordset2.Rows;

    _dispatch({ type: GET_DATA_AJUSTES_CARGOS_FILTRO, dataModalFiltrosCargoAjuste });
    _dispatch({ type: LOADING_CONFIRMADOR, valor: false });
}

//Valido que la fecha desde no sea mayor a la fecha hasta
function validarFechasDesdeHasta(fechaDesde, fechaHasta) {
    let fechaDesdeFinal, fechaHastaFinal, fechaDesdeAux, fechaHastaAux, validaFecha;

    if (typeof fechaDesde == "object") {
        fechaDesdeAux = fechaDesdeAux.toLocaleDateString();
        fechaDesdeAux = fechaDesdeAux.length == 9 ? "0" + fechaDesdeAux : fechaDesdeAux;
    } else {
        fechaDesdeAux = fechaDesde;
    }

    if (typeof fechaHasta == "object") {
        fechaHastaAux = fechaHastaAux.toLocaleDateString();
        fechaHastaAux = fechaHastaAux.length == 9 ? "0" + fechaHastaAux : fechaHastaAux;
    } else {
        fechaHastaAux = fechaHasta;
    }

    fechaDesdeAux = fechaDesdeAux.split("/");
    let dia = fechaDesdeAux[0];
    let mes = fechaDesdeAux[1];
    let anio = fechaDesdeAux[2];
    fechaDesdeAux = mes + "/" + dia + "/" + anio;
    fechaDesdeFinal = new Date(fechaDesdeAux);

    fechaHastaAux = fechaHastaAux.split("/");
    dia = fechaHastaAux[0];
    mes = fechaHastaAux[1];
    anio = fechaHastaAux[2];
    fechaHastaAux = mes + "/" + dia + "/" + anio;
    fechaHastaFinal = new Date(fechaHastaAux);

    if (fechaDesdeFinal > fechaHastaFinal)
        validaFecha = false;
    else
        validaFecha = true;

    return validaFecha;
}

function obtenerFechaEstadoDenegado() {

    let fechaAux, fecha, fechaFormateada;

    fechaAux = new Date();
    fecha = new Date(fechaAux.setDate(fechaAux.getDate() - 30));

    fechaFormateada = (fecha.getDate() > 9 ? fecha.getDate() : '0' + fecha.getDate()) + '/' + (fecha.getMonth() > 9 ? fecha.getMonth() : '0' + fecha.getMonth()) + '/' + fecha.getFullYear();

    return fechaFormateada;
}

function validarMinimoPermitidoFecha(fecha) {
    let fechaAux = fecha.split("/");
    let fechaFinal, fechaMinima, fechaMinimaSuperada, mes, anio;

    mes = fechaAux[0];
    anio = fechaAux[1];
    fechaAux = mes + "/" + "01" + "/" + anio;
    fechaFinal = new Date(fechaAux);
    fechaMinima = new Date("04/01/2020");

    if ((fechaFinal < fechaMinima) || (fechaFinal == "Invalid Date"))
        fechaMinimaSuperada = true;
    else
        fechaMinimaSuperada = false;

    return fechaMinimaSuperada;
}

function validarFechaPosterior(fecha) {
    let fechaAux = fecha.split("/");
    let fechaFinal;
    let fechaPosterior;

    let dia = fechaAux[0]
    let mes = fechaAux[1];
    let anio = fechaAux[2];
    fechaAux = mes + "/" + dia + "/" + anio;

    fechaFinal = new Date(fechaAux);

    if ((fechaFinal > new Date()) || (fechaFinal == "Invalid Date"))
        fechaPosterior = true;
    else
        fechaPosterior = false;

    return fechaPosterior;
}


export function destildarTildarCheck(movimientoId, tipoCheck, estadoCheck) {
    LogHelper.In(destildarTildarCheck.name, movimientoId, tipoCheck, estadoCheck);

    let checkConfirmar = undefined;
    let checkDenegarRestablecer = undefined;

    tipoCheck == "C" ? checkConfirmar = movimientoId : checkDenegarRestablecer = movimientoId;

    return () => {
        _dispatch({ type: DESTILDAR_TILDAR_CHECK, checkConfirmarId: checkConfirmar, checkDenegarRestablecerId: checkDenegarRestablecer, estado: estadoCheck });
    }
}


export function destildarTildarCheckAll(tipoCheck, estadoCheck, ajusteCargo) {
    LogHelper.In(destildarTildarCheckAll.name, tipoCheck, estadoCheck, ajusteCargo);

    let ajusteCargoIdArray = ajusteCargo.map(ajusteCargo => ajusteCargo.Id);

    let checkConfirmar = tipoCheck == "C" ? !estadoCheck : undefined;
    let checkDenegarRestablecer = checkConfirmar ? undefined : !estadoCheck;

    return () => {
        _dispatch({ type: DESTILDAR_TILDAR_CHECK_ALL, checkConfirmar: checkConfirmar, checkDenegarRestablecer: checkDenegarRestablecer, ajusteCargoIdArray: ajusteCargoIdArray });
    }
}

export function obtenerDatosGrilla(data) {
    return () => {
        if (!data.errorMin && !data.errorMax) {
            let errorImportes = data.importeMin && data.importeMax && parseFloat(data.importeMin) > parseFloat(data.importeMax);

            if(!errorImportes) {
                let tipoOper = null;
                let fechaD = null;
                let fechaH = null;

                if ((data.tipoOperacion.credito && data.tipoOperacion.debito) || (!data.tipoOperacion.credito && !data.tipoOperacion.debito)) {
                    tipoOper = null;
                } else {
                    tipoOper = data.tipoOperacion.credito ? 1 : 0;
                }

                let estadoId = data.tipoMovimiento == "A" ? data.estado.idEstadoAjuste : data.estado.idEstadoCargo;

                fechaD = data.estado && data.estado.fechaDesde ? data.estado.fechaDesde.substring(3, 5) + "-" + data.estado.fechaDesde.substring(0, 2) + "-" + data.estado.fechaDesde.substring(6, 10) : null;
                fechaH = data.estado && data.estado.fechaHasta ? data.estado.fechaHasta.substring(3, 5) + "-" + data.estado.fechaHasta.substring(0, 2) + "-" + data.estado.fechaHasta.substring(6, 10) : null;

                let param = {
                    "TIPO_MOVIMIENTO": data.tipoMovimiento,
                    "ID_MARCA": data.marca && data.marca > 0 ? parseInt(data.marca,10) : null,
                    "TIPO_OPERACION": tipoOper,
                    "TIPO_CUENTA_ID": data.tipoCuenta && data.tipoCuenta > 0 ? parseInt(data.tipoCuenta,10) : null,
                    "IMPORTE_MINIMO": data.importeMin,
                    "IMPORTE_MAXIMO": data.importeMax,
                    "ESTADO_ID": estadoId,
                    "USUARIO": data.estado && data.estado.login ? data.estado.login.Login : null,
                    "FECHA_ESTADO_DESDE": fechaD,
                    "FECHA_ESTADO_HASTA": fechaH,
                    "MOTIVO_AJUSTE_CARGO": null
                }

                let motivosConceptosSeleccionados = data.motivosSeleccionados;

                Engine1Proxy.AddDataSourcesRequests(param, 'GET_AJUSTES_CARGOS_CONFIRMADOR_GRILLA', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
                Engine1Proxy.Execute((data) => _callBackObtenerDatosGrilla(data, motivosConceptosSeleccionados), null, null, "CONSULTASOCIOS");

                _dispatch({ type: LOADING_CONFIRMADOR, valor: true });
            } else {
                _dispatch({ type: ABRIR_MODAL, muestraModal: true, modalId: 5 });
            }
        }
    }
}

function _callBackObtenerDatosGrilla(data, motivosConceptosSeleccionados) {
    let dataDatosGrilla = JSON.parse(data.GET_AJUSTES_CARGOS_CONFIRMADOR_GRILLA).Recordset0.Rows;

    let motivosSeleccionados = undefined;

    if (motivosConceptosSeleccionados && motivosConceptosSeleccionados.length > 0) {
        motivosSeleccionados = motivosConceptosSeleccionados.map(x => x.Codigo)
    }

    dataDatosGrilla = motivosSeleccionados ? dataDatosGrilla.filter(datos => motivosSeleccionados.includes(datos.Codigo)) : dataDatosGrilla;

    _dispatch({ type: LOADING_CONFIRMADOR, valor: false });
    _dispatch({ type: MOSTRAR_DATOS_GRILLA, ajusteCargo: dataDatosGrilla });
}


export function ocultarModalConfirmador() {
    return () => {
        _dispatch({ type: ABRIR_MODAL, muestraModal: false, modalId: 5 });
    }
}

export function borrarFiltros() {
    return () => {
        _dispatch({ type: LOADING_CONFIRMADOR, valor: true });
        //Reseteo a estado inicial de la pantalla
        _dispatch({ type: INITIAL_STATE });

        _loadConfirmadorAjusteCargo(null, true);
    }
}


export function mostrarModalCambiarEstado(mostrarModalCambiarEstado, totalMovimientos) {
    return () => {
        totalMovimientos > 0 ?
        _dispatch({ type: MOSTRAR_MODAL_CAMBIAR_ESTADO, mostrarModalCambiarEstado })
        :
        _dispatch({ type: ABRIR_MODAL, muestraModal: true, modalId: 6 })
    }
}


export function ocultarModalCambiarEstado() {
    return () => {
        _dispatch({ type: ABRIR_MODAL, muestraModal: false, modalId: 6 });
    }
}